import { Inject } from '../Application';
import { Constants } from '../Contract';
import { ClientClose } from './Command';
var View = (function () {
    function View(model, inject) {
        if (inject === void 0) { inject = null; }
        var myInject = inject || Inject.Instance;
        this.model = model;
        this.model['view'] = this;
        this.invoker = myInject.resolve(Constants.Invoker);
        this.bindings();
        this.timersToCleanup = new Array();
    }
    Object.defineProperty(View.prototype, "name", {
        get: function () {
            return this._name;
        },
        set: function (value) {
            this._name = value;
        },
        enumerable: false,
        configurable: true
    });
    View.prototype.close = function () {
        this.cleanupTimers();
        this.dispose();
    };
    View.prototype.requestClose = function () {
        this.invoke(new ClientClose(this));
    };
    View.prototype.load = function () {
        if (this.onLoad) {
            this.onLoad(this, null);
        }
        this.render();
        if (this.onPostLoad) {
            this.onPostLoad(this, null);
        }
    };
    View.prototype.bind = function (action, delegate) {
        var _this = this;
        this.model[action] = function (e) {
            if (delegate) {
                return delegate(_this, action, e);
            }
        };
    };
    View.prototype.invoke = function (command) {
        this.invoker.invoke(command);
    };
    View.prototype.registerTimer = function (timerInfo) {
        this.timersToCleanup.push(timerInfo);
    };
    View.prototype.cleanupTimers = function () {
        this.timersToCleanup.forEach(function (timerInfo) {
            if (timerInfo && timerInfo.clearTimer) {
                timerInfo.clearTimer();
            }
        });
    };
    return View;
}());
export { View };
